<template>
  <x-bottom-bar v-if="cartModel.goodsCount" :no-safe-area="true">
    <div :class="[_.bar, _._hairlineBottom]">
      <div :class="_.selectAll" @click="cartModel.selectAll">
        <CartCheckbox :checked="cartModel.isSelectAll" />
        <div :class="_.text">全选</div>
      </div>
      <div :class="_.grow"></div>
      <template v-if="cartModel.isDisplayMode">
        <div :class="_.price">合计：￥{{ cartModel.selectedGoodsPrice }}</div>
        <div
          v-track="{
            name: '去结算',
            id: '79fe234d-5bda-41de-8ad9-5b984e785936',
          }"
          :class="[_.button, _.checkOut]"
          @click="cartModel.checkout()"
        >
          去结算({{ cartModel.selectedValidGoodsCount }})
        </div>
      </template>
      <template v-else>
        <div
          v-track="{
            name: '购物车-移入收藏夹',
            id: '8ee14187-1aa9-4fd3-82fd-013ed369bde0',
          }"
          :class="[_.button, _.favorite]"
          @click="cartModel.moveSelectedToFavorite()"
        >
          移入收藏夹
        </div>
        <div
          v-track="{
            name: '购物车-删除',
            id: 'db619161-d9b5-499c-ad19-74c34a6d6da3',
          }"
          :class="[_.button, _.delete]"
          @click="cartModel.deleteSelected()"
        >
          删除
        </div>
      </template>
    </div>
  </x-bottom-bar>
</template>

<script>
  import CartCheckbox from './checkbox.vue'
  import { cartModelProvider } from '../model'
  import { defineClassComponent } from '@/hooks'

  export default defineClassComponent(
    {
      components: {
        CartCheckbox,
      },
    },
    () =>
      class {
        cartModel = cartModelProvider.inject()
      },
  )
</script>

<style lang="scss" module>
  .bar {
    height: 50px;
    background: #ffffff;
    box-shadow: 0px -2px 2px 0px rgba(245, 245, 245, 1);
    display: flex;
    align-items: center;
    padding: 0 12px;

    .selectAll {
      flex-shrink: 0;
      display: flex;
      align-items: center;

      .text {
        flex-shrink: 0;
        margin-left: 8px;
        font-size: 14px;
        color: #222222;
        line-height: 20px;
      }
    }

    .grow {
      flex-grow: 1;
    }

    .price {
      flex-shrink: 0;
      font-size: 14px;
      font-weight: var(--bold-value);
      color: #ff111c;
      line-height: 20px;
    }

    .button {
      flex-shrink: 0;
      margin-left: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
      border-radius: 100px;
      height: 34px;

      &.checkOut {
        width: 100px;
        background: linear-gradient(131deg, #ff7e43 0%, #ff111c 100%);
      }

      &.favorite {
        width: 110px;
        background: linear-gradient(131deg, #ffac3d 0%, #e3bc47 100%);
      }

      &.delete {
        width: 68px;
        background: linear-gradient(131deg, #ff7e43 0%, #ff111c 100%);
      }

      &:active {
        opacity: 0.8;
      }

      + .button {
        margin-left: 12px;
      }
    }
  }
</style>
